var countryList = [
                {
                    'countrycode':'AR',
                    'countryname': 'Argentina'
                },
                {
                    'countrycode':'AU',
                    'countryname': 'Australia'
                },
                {
                    'countrycode':'BE',
                    'countryname': 'Belgium'
                },
                {
                    'countrycode':'BR',
                    'countryname': 'Brazil'
                },
                {
                    'countrycode':'BG',
                    'countryname': 'Bulgaria'
                },
                {
                    'countrycode':'CA',
                    'countryname': 'Canada'
                },
                
                {
                    'countrycode':'CL',
                    'countryname': 'Chile'
                },
                
                {
                    'countrycode':'CN',
                    'countryname': 'China'
                },
                
                {
                    'countrycode':'CO',
                    'countryname': 'Colombia'
                },
                
                {
                    'countrycode':'CR',
                    'countryname': 'Costa Rica'
                },
                
                {
                    'countrycode':'HR',
                    'countryname': 'Croatia'
                },
                
                {
                    'countrycode':'CZ',
                    'countryname': 'Czech Republic'
                },
                {
                    'countrycode':'DK',
                    'countryname': 'Denmark'
                },
                {
                    'countrycode':'EG',
                    'countryname': 'Egypt'
                },
                {
                    'countrycode':'EE',
                    'countryname': 'Estonia'
                },
                {
                    'countrycode':'FI',
                    'countryname': 'Finland'
                },
                {
                    'countrycode':'FR',
                    'countryname': 'France'
                },
                {
                    'countrycode':'DE',
                    'countryname': 'Germany'
                },
                {
                    'countrycode':'GR',
                    'countryname': 'Greece'
                },
                {
                    'countrycode':'GT',
                    'countryname': 'Guatemala'
                },
                {
                    'countrycode':'HK',
                    'countryname': 'Hong Kong'
                },
                {
                    'countrycode':'HU',
                    'countryname': 'Hungary'
                },
                {
                    'countrycode':'IN',
                    'countryname': 'India'
                },
                {
                    'countrycode':'ID',
                    'countryname': 'Indonesia'
                },
                {
                    'countrycode':'IL',
                    'countryname': 'Israel'
                },
                {
                    'countrycode':'IT',
                    'countryname': 'Italy'
                },
                {
                    'countrycode':'JP',
                    'countryname': 'Japan'
                },
                {
                    'countrycode':'JO',
                    'countryname': 'Jordan'
                },
                {
                    'countrycode':'KZ',
                    'countryname': 'Kazakhstan'
                },
                {
                    'countrycode':'KW',
                    'countryname': 'Kuwait'
                },
                {
                    'countrycode':'LV',
                    'countryname': 'Latvia'
                },
                {
                    'countrycode':'LT',
                    'countryname': 'Lithuania'
                },
                {
                    'countrycode':'MY',
                    'countryname': 'Malaysia'
                },
                {
                    'countrycode':'MX',
                    'countryname': 'Mexico'
                },
                {
                    'countrycode':'NL',
                    'countryname': 'Netherlands'
                },
                {
                    'countrycode':'NZ',
                    'countryname': 'New Zealand'
                },
                {
                    'countrycode':'NO',
                    'countryname': 'Norway'
                },
                {
                    'countrycode':'PE',
                    'countryname': 'Peru'
                },
                {
                    'countrycode':'PH',
                    'countryname': 'Philippines'
                },
                {
                    'countrycode':'PL',
                    'countryname': 'Poland'
                },
                {
                    'countrycode':'PT',
                    'countryname': 'Portugal'
                },
                {
                    'countrycode':'QA',
                    'countryname': 'Qatar'
                },
                {
                    'countrycode':'RO',
                    'countryname': 'Romania'
                },
                {
                    'countrycode':'SA',
                    'countryname': 'Saudi Arabia'
                },
                {
                    'countrycode':'RS',
                    'countryname': 'Serbia'
                },
                {
                    'countrycode':'SG',
                    'countryname': 'Singapore'
                },
                {
                    'countrycode':'SI',
                    'countryname': 'Slovenia'
                },
                {
                    'countrycode':'KR',
                    'countryname': 'South Korea'
                },
                {
                    'countrycode':'ES',
                    'countryname': 'Spain'
                },
                {
                    'countrycode':'SE',
                    'countryname': 'Sweden'
                },
                {
                    'countrycode':'CH',
                    'countryname': 'Switzerland'
                },
                {
                    'countrycode':'TW',
                    'countryname': 'Taiwan Region'
                },
                {
                    'countrycode':'TH',
                    'countryname': 'Thailand'
                },
                {
                    'countrycode':'TR',
                    'countryname': 'Turkey'
                },
                {
                    'countrycode':'UA',
                    'countryname': 'Ukraine'
                },
                {
                    'countrycode':'AE',
                    'countryname': 'United Arab Emirates'
                },
                {
                    'countrycode':'GB',
                    'countryname': 'United Kingdom'
                },
                {
                    'countrycode':'US',
                    'countryname': 'United States'
                },
                {
                    'countrycode':'UY',
                    'countryname': 'Uruguay'
                },
                {
                    'countrycode':'VN',
                    'countryname': 'Vietnam'
                },
  
             ];

function getcountrycode(fetchcountrycode) {    
    let countryindex     = countryList.findIndex((item) => item.countryname === fetchcountrycode);  
    if (countryindex !== -1) {
       currentcodecode = countryList[countryindex]['countrycode'];
    } else {      
      currentcodecode = 'notexist';
    }
    return currentcodecode;  
}

var languageList = [
                {
                    'langcode':'EN',
                    'langname': 'English'
                },
                {
                    'langcode':'AR',
                    'langname': 'Arabic'
                },
                {
                    'langcode':'DE',
                    'langname': 'Deutsch'
                },
                {
                    'langcode':'ES',
                    'langname': 'Español'
                },
                {
                    'langcode':'ES419',
                    'langname': 'Español (LATAM)'
                },
                {
                    'langcode':'FR',
                    'langname': 'Français'
                },
                {
                    'langcode':'IT',
                    'langname': 'Italiano'
                },
                {
                    'langcode':'ID',
                    'langname': 'Bahasa Indonesia'
                },
                {
                    'langcode':'PL',
                    'langname': 'Polski'
                },
                {
                    'langcode':'ptBR',
                    'langname': 'Português (Brasil)'
                },
                {
                    'langcode':'RU',
                    'langname': 'Pyccкий'
                },
                {
                    'langcode':'VI',
                    'langname': 'Tiếng Việt'
                },
                {
                    'langcode':'TR',
                    'langname': 'Türkçe'
                },
                {
                    'langcode':'TH',
                    'langname': 'ไทย'
                },
                {
                    'langcode':'KO',
                    'langname': '한국어'
                },
                {
                    'langcode':'zhCN',
                    'langname': '中文(简体)'
                },
                {
                    'langcode':'zhTW',
                    'langname': '中文(繁體)'
                },
                {
                    'langcode':'JA',
                    'langname': '日本語'
                },
  
            ];

const storelist = [
              {
                  storeCode: "CA",
                  storeName: "Canada",
                  storeUrl: "https://ca.hyperx.com/",
                  supportedLanguages: "EN, FR",
                  defaultLanguage: "EN",
                  supportedCurrencies: "CAD",
                  supportedStores: "CA"
              },
              // {
              //     storeCode: "hyperx-ca",
              //     storeName: "Legacy HyperX Canada",
              //     storeUrl: "https://hyperx-ca.myshopify.com/",
              //     supportedLanguages: "EN, FR",
              //     defaultLanguage: "EN",
              //     supportedCurrencies: "CAD",
              //     supportedStores: "CA"
              // },
              {
                  storeCode: "US",
                  storeName: "United States",
                  storeUrl: "https://hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "USD",
                  supportedStores: "US"
              }, 
              {
                  storeCode: "AU",
                  storeName: "Australia",
                  storeUrl: "https://au.hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "AUD",
                  supportedStores: "AU"
              }, 
              {
                  storeCode: "ROW",
                  storeName: "Global",
                  storeUrl: "https://row.hyperx.com/",
                  supportedLanguages: "EN, AR, DE, ES, ES419, FR, IT, ID, PL, pt-BR, RU, VI, TR, TH, KO, zh-CN, zh-TW, JA",
                  defaultLanguage: "EN",
                  supportedCurrencies: "USD",
                  supportedStores: "AF,AX,AL,DZ,AS,AD,AO,AI,AQ,AG,AR,AM,AW,AT,AZ,BS,BH,BD,BB,BE,BZ,BJ,BM,BT,BO,BQ,BA,BW,BR,IO,BN,BG,BF,BI,KH,CM,CV,KY,CF,TD,CL,CN,CX,CC,CO,KM,CG,CK,CR,CI,HR,CW,CY,CZ,CD,DK,DJ,DM,DO,EC,EG,SV,GQ,ER,EE,ET,FK,FO,FJ,FI,FR,GF,PF,TF,GA,GM,GE,GH,GI,GR,GL,GD,GP,GU,GT,GN,GW,GY,HT,VA,HN,HK,HU,IS,IN,ID,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KR,XK,KW,KG,LA,LV,LB,LS,LR,LI,LT,LU,MO,MK,MG,MW,MY,MV,ML,MT,MH,MQ,MR,MU,YT,MX,FM,MD,MC,MN,ME,MS,MA,MZ,MM,NA,NR,NP,NL,NC,NZ,NI,NE,NG,NU,NF,MP,NO,OM,PK,PW,PS,PA,PG,PY,PE,PH,PN,PL,PT,PR,QA,RE,RO,RW,BL,SH,KN,LC,MF,PM,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SX,SK,SI,SB,ZA,GS,SS,ES,LK,SD,SR,SJ,SZ,SE,CH,TW,TJ,TZ,TH,TL,TG,TK,TO,TT,TN,TR,TM,TC,TV,UG,UA,AE,UM,UY,UZ,VU,VN,VG,VI,WF,EH,ZM,ZW"
              }, 
              {
                  storeCode: "GB",
                  storeName: "United Kingdom",
                  storeUrl: "https://uk.hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "GBP",
                  supportedStores: "GB"
              }, 
              {
                  storeCode: "DE",
                  storeName: "Germany",
                  storeUrl: "https://de.hyperx.com/",
                  supportedLanguages: "DE, EN",
                  defaultLanguage: "DE",
                  supportedCurrencies: "EUR",
                  supportedStores: "DE"
              },
              {
                  storeCode: "FR",
                  storeName: "France",
                  storeUrl: "https://fr.hyperx.com/",
                  supportedLanguages: "EN, FR",
                  defaultLanguage: "FR",
                  supportedCurrencies: "EUR",
                  supportedStores: "FR"
              },
              {
                  storeCode: "Sandbox",
                  storeName: "Sandbox",
                  storeUrl: "https://hyperx-gg.myshopify.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN, DE, FR, IT, ID",
                  supportedCurrencies: "USD",
                  supportedStores: "Sandbox"
              }
          ];

      /*
       ------------------------------------------------------------------------------
          getCurrentlanguageCodeDetails: Get the current store language details from cookie
        ------------------------------------------------------------------------------
      */
      
      function getCurrentlanguageCodeDetails() {
        var currentstorecode = getCookie('continueStoreinfo');   
        const cookieArray = currentstorecode.split(",");
        let storelanguage = cookieArray[0].toUpperCase();
      
        return storelanguage;
       
      }

      /*
       ------------------------------------------------------------------------------
          getCurrentStoreCodeDetails: Get the current store code details from cookie
        ------------------------------------------------------------------------------
      */
      
      function getCurrentStoreCodeDetails() {
        var currentstorecode = getCookie('continueStoreinfo');   
        const cookieArray = currentstorecode.split(",");  
        let storecode     = cookieArray[1];
      
        return storecode;
      }


  function getstorecode(fetchcountrycode) {           
      var i = 0;
      while (i < storelist.length) {
      var supportedStores = storelist[i].supportedStores;
      var supportedStoressplit = supportedStores.split(",");
      for (var g in supportedStoressplit){
        if( fetchcountrycode == supportedStoressplit[g] ){          
          currentstorecode = storelist[i]['storeCode'];
        }        
      }              
      i++;
    }
    return currentstorecode;
  }

function getstoreurl(storeCode) {
    let storeIndex = storelist.findIndex((item) => item.storeCode === storeCode);

    // Ensure storeIndex is valid before accessing storelist[storeIndex]
    if (storeIndex !== -1) {
        return storelist[storeIndex].storeUrl; 
    } else{
        return '';
    }
}

function getcontinuestoreurl(storecode) {
  const requestpath = window.location.pathname;
  let storeindex  = storelist.findIndex((item) => item.storeCode === storecode);
  let storeurl    = storelist[storeindex]['storeUrl'];
  let defaultlang = getdefaultLanguage(storecode);
  //var redirectLink = storeurl+'?loc='+countrycode +'&lang='+defaultlang;
  
  //var redirectLink = storeurl+'?lang='+defaultlang;

  const fullUrl = window.location.href;        
  const urlObj = new URL(fullUrl);    
  // Extract the pathname and search query
  const extractedUrl = urlObj.pathname + urlObj.search;    
  // Construct the base store URL
  const cleanedUrl = storeurl + (extractedUrl.startsWith("/") ? extractedUrl.substring(1) : extractedUrl);    
  // Remove existing `loc` parameter while preserving others
  const params = new URLSearchParams(urlObj.search);
  params.delete("loc");    
  // Append the new `loc` value
  params.append("loc", countryCode);    
  // Construct the final corrected URL
  const redirectLink = cleanedUrl.split("?")[0] + "?" + params.toString();
  
  return redirectLink;
}

function getstorename(storecode) {
  let storeindex     = storelist.findIndex((item) => item.storeCode === storecode);
  let storename    = storelist[storeindex]['storeName'];
  return storename;
}

function getsupportedCurrencies(storecode) {
  let storeindex     = storelist.findIndex((item) => item.storeCode === storecode);
  let supportedCurrencies    = storelist[storeindex]['supportedCurrencies'];
  return supportedCurrencies;
}

function getdefaultLanguage(storecode) {
  let storeindex     = storelist.findIndex((item) => item.storeCode === storecode);
  let defaultLanguage    = storelist[storeindex]['defaultLanguage'];
  return defaultLanguage;
}

function getsupportedLanguages(storecode) {  
  let storeindex            = storelist.findIndex((item) => item.storeCode === storecode);    
  let supportedLanguages    = storelist[storeindex]['supportedLanguages'];  
  return supportedLanguages;
}

function getsupportedStores(storecode) {
  let storeindex     = storelist.findIndex((item) => item.storeCode === storecode);
  let supportedStores= storelist[storeindex]['supportedStores'];
  return supportedStores;
}


//alert(getdefaultLanguage('Sandbox'));

function footersettingsButton() {   
    allcountrylist();
    document.getElementById('choiceContainer').style.display = 'none';
    document.getElementById('settingsContainer').style.display = 'block';
    document.getElementById('back_btn').style.display = 'block';
  
}

function footerBackButton() {   
    document.getElementById('choiceContainer').style.display = 'block';
    document.getElementById('settingsContainer').style.display = 'none';
    document.getElementById('back_btn').style.display = 'none';
  
}



function buildDropDowns(supportLanguage) {
    var selections = document.getElementsByClassName('languagelist');  
    for(var i=0; i<selections.length; i++) {      
      selections[i].options.add(createOption('EN', 'Select Language'));
      for(var j= 0; j<supportLanguage.length; j++) {        
         let langindex  = languageList.findIndex((item) => item.langcode === supportLanguage[j]);
          
          if(langindex != -1) {
             let langvalue  = languageList[langindex]['langname'];
             selections[i].options.add(createOption(supportLanguage[j], langvalue));
          }
        
      }
    }
}

function createOption(optioncode, label) {
  var option     = document.createElement("option");
  option.setAttribute("value", optioncode);
  option.innerHTML = label;  
  return option;
}

function countrySelect() {
  const requestpath = window.location.pathname;
  var countrycode = document.getElementById("RedirectCountry").value;
  var storecode = getstorecode(countrycode);  
  var supportLanguage = getsupportedLanguages(storecode);  
  var storeurl    = getstoreurl(storecode);
  var defaultlang = getdefaultLanguage(storecode);
  var redirectLink = storeurl+'?loc='+countrycode +'&lang='+defaultlang;  
  
  $("#RedirectSettings").attr("action", redirectLink);  
  const supportedlanguage = supportLanguage.split(", ");  
  $("#RedirectLanguage").empty(); // remove old options    
  buildDropDowns(supportedlanguage); // build new options of language
}

function languageSelect(){
  var classname = document.getElementById('popup-content');
  const requestpath = window.location.pathname;  
  var langCode= requestpath.split("/");
  var lang = langCode[1];
  
  var countrycode = document.getElementById("RedirectCountry").value;  
  var storecode   = getstorecode(countrycode);
  var storeurl    = getstoreurl(storecode);
  var defaultlang = getdefaultLanguage(storecode);
  var selectedlang = document.getElementById("RedirectLanguage").value; 
  
  if(defaultlang == selectedlang){
    var redirectLink = storeurl+requestpath+'?loc='+countrycode +'&lang='+selectedlang;
    redirectLink = redirectLink.replace('/'+lang, '');       
  } else {
    var redirectLink = storeurl+selectedlang.toLowerCase()+requestpath+'?loc='+countrycode;
  }

  $("#RedirectSettings").attr("action", redirectLink);
  
}

 function setContinueCookie(cname, cvalue, exdays) {
     
     document.getElementById('popup').style.display = 'none';
     var newdate = new Date();
     newdate.setTime(newdate.getTime() + (exdays*24*60*60*1000));
     var expires = "expires="+newdate.toUTCString();
     document.cookie = cname + "=" + cvalue + "; " + expires;
   }

 function getCookie(cname) {
       var name = cname + "=";
       var ca = document.cookie.split(';');
       for(var i=0; i<ca.length; i++) {
           var c = ca[i];
           while (c.charAt(0)==' ') c = c.substring(1);
           if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
       }
       return "";
   }

function allcountrylist() {
  var currentstorecode = getCurrentStoreCodeDetails();
  
    if(currentstorecode != null) {      
      selectedlanguage();
       var currentcountrycode = getsupportedStores(currentstorecode);         
    }  
      var options = "";
      options += "<option value='ROW'>Select Country/Region</option>";   
  
      for (let j = 0; j<countryList.length; j++) {
        var countrycode = countryList[j].countrycode;
        var countryname = countryList[j].countryname;       
          if(currentcountrycode === countrycode) {
            options += "<option value='" + countrycode + "' selected>" + countryname + "</option>";       
          } else {
            options += "<option value='" + countrycode + "'>" + countryname + "</option>";       
          }
            
      }  
    $('#RedirectCountry').html(options);   
}

function selectedlanguage() {  
  var currentstorecode = getCurrentStoreCodeDetails();    
  var supportedlanguage = getsupportedLanguages(currentstorecode);  
  var currentlanguage = getCurrentlanguageCodeDetails();  
  
  const supportlanguage = supportedlanguage.split(", ");
    var options = "";
      options += "<option>Select Language</option>";       
      for (let j = 0; j<supportlanguage.length; j++) {
        var langcode = supportlanguage[j];
        let langindex  = languageList.findIndex((item) => item.langcode === supportlanguage[j]);        
        let langvalue  = languageList[langindex]['langname'];
        
          if( currentlanguage == langcode ) {
            options += "<option value='" + langcode + "' selected>" + langvalue + "</option>";       
          } else {
            options += "<option value='" + langcode + "'>" + langvalue + "</option>";       
          }
            
      }  
    $('#RedirectLanguage').html(options); 
 
}


/* Product Image Gallery vertical slider code for PDP page */

 document.addEventListener("DOMContentLoaded", () => {
    const sliderContainer = document.querySelector('ul.thumbnail-list.list-unstyled.slider.slider--mobile.slider--tablet-up');
    const topbutton = document.querySelector("button#top");
    if (topbutton) {
        topbutton.addEventListener("click", () => {
          sliderContainer.scrollBy({
          top: 600, // Scroll up by 100px; adjust value as needed
          behavior: 'smooth', // Smooth scrolling effect
        });
      });
    }

    const downbutton = document.querySelector("button#down");
    if (downbutton) {
        downbutton.addEventListener("click", () => {
          sliderContainer.scrollBy({
          top: -600, // Scroll up by 100px; adjust value as needed
          behavior: 'smooth', // Smooth scrolling effect
        });
      });
    }
  });


/* Product Details Page Gallery Images Changed Based on variant selection Code start */

document.addEventListener("DOMContentLoaded", function() {
  var variantLabel = document.querySelector(".variantOption");
  if (variantLabel) {
      variantSelect(variantLabel.id); // Auto-trigger on page load
  }
});

document.addEventListener("DOMContentLoaded", function() {
    let activeVariant = document.querySelector(".variantactive");
    if (activeVariant) {
        variantSelect(activeVariant.id);        
    }
});

 document.addEventListener("DOMContentLoaded", function() {   
    // Select main product image (use querySelector to get a single element)
    let mainImage = document.querySelector(".product__media img");        

    // Select all thumbnails
    let thumbnails = document.querySelectorAll(".global-media-settings");

    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener("click", function() {
            let newImageSrc = thumbnail.querySelector("img").getAttribute("src");                                
            if (mainImage && newImageSrc) {                                         
                mainImage.setAttribute("src", newImageSrc);
                mainImage.setAttribute("srcset", newImageSrc);               
            } 
        });
    });

});

 function variantSelect(classSelectedName) {   
       document.querySelectorAll('.slider__slide').forEach(slide => {
        // slide.style.display = "";
        slide.classList.forEach(className => {
            if (className.includes("variantImage-") && className === classSelectedName) {
                let parentList = document.querySelector(".thumbnail-list");
                let variantItems = parentList.querySelectorAll("." + classSelectedName);
                // Move selected items to the top
                variantItems.forEach(item => {
                    parentList.prepend(item);
                });              
            }
        });
    });

    // custom js to manage where to buy link on variant change

    function getCountryCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    setTimeout(function () {
        const productType = document.querySelector(".wtb_links").getAttribute("data-product-type").toLowerCase();

        let jsonString = "";
        if (productType !== "monitors" && productType !== "gaming keyboards") {
        jsonString = document.getElementById("wheretobuy_links_variant").value;
        } else {
        jsonString = document.getElementById("wheretobuy_links_product").value;
        }
        //const jsonString = document.getElementById("wheretobuy_links").value;
        
        let linksData = {};
        if (jsonString && jsonString.trim() !== "") {
            try {
            linksData = JSON.parse(jsonString);
            } catch (e) {
            console.error("Invalid JSON:", e);
            }
        }
        let country = "";
        let countryTxt = getCountryCookie("customer_country"); // Get Country value from cookie    

        if (countryTxt !== undefined) {
        country = countryTxt.toLowerCase();  
        }

        if (jsonString !== "" && country !== "") {
        if (country in linksData) {
            if (linksData[country] !== "") { 
                const link = document.getElementById("wheretobuy");
                link.href = linksData[country];
                link.target = "_blank";
                link.title = "";
                document.getElementById("custom-count-atc").innerHTML = "Where to Buy";
                document.getElementById("wheretobuy").classList.remove("disable-wheretobuy");
            } else {
                const link = document.getElementById("wheretobuy");
                link.title = "";
            }
        }
        }
    }, 1000);
  }

/* Product Details Page Gallery Images Changed Based on variant selection Code end */

function setcustomCountry() {    
    const dropdown = document.querySelector("select[name='location']");
    const countryCode = dropdown.value;
    const storeCode = getstorecode(countryCode);    
    const storeurl    = getstoreurl(storeCode);      
    const storeLang = document.body.getAttribute("lang");
    const currentStoreCode = storeLang.replace(/^.*-/, ""); // Extracts "row"    
    const currentLanguageCode = storeLang.substring(0, 2);
    let exists = getstoreurl(currentLanguageCode.toUpperCase());  

    const supportLanguage = getsupportedLanguages(storeCode);

    let supportlanguageexists = supportLanguage.includes(currentLanguageCode.toUpperCase());

    var check_customer_country = getCookie('customer_country');
    if (!check_customer_country || check_customer_country !== countryCode) {
      setCustomerLocation(countryCode);        
    }
    const fullUrl = window.location.href;        
    const urlObj = new URL(fullUrl);    
    // Extract the pathname and search query
    const extractedUrl = urlObj.pathname + urlObj.search;    
    // Construct the base store URL
    const cleanedUrl = storeurl + (extractedUrl.startsWith("/") ? extractedUrl.substring(1) : extractedUrl);    
    // Remove existing `loc` parameter while preserving others
    const params = new URLSearchParams(urlObj.search);
    params.delete("loc");    
    // Append the new `loc` value
    params.append("loc", countryCode);    
    // Construct the final corrected URL
    let completeUrl = cleanedUrl.split("?")[0] + "?" + params.toString();

   if (exists !== '' && countryCode === currentLanguageCode.toUpperCase()) {
        completeUrl = completeUrl.replace("/"+currentLanguageCode+"?", "?");
        completeUrl = completeUrl.replace("/"+currentLanguageCode+"/", "/");
   }

   if (supportlanguageexists == false) {
        completeUrl = completeUrl.replace("/"+currentLanguageCode+"?", "?");
        completeUrl = completeUrl.replace("/"+currentLanguageCode+"/", "/");
   }

    window.location.href = completeUrl;            
}

function setCustomerLocation(currentlocation){
  var newdate = new Date();
  var exdays = 7;
  newdate.setTime(newdate.getTime() + (exdays*24*60*60*1000));    
  var expires = "expires="+newdate.toUTCString();                                              
  document.cookie = "customer_country=" + currentlocation + "; path=/; " + expires;     
  
}
